import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Alert from "react-s-alert";
import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import Image from "react-bootstrap/Image";
import ReasonForCancellation from "../reasonForCancellation/ReasonForCancellation";
//import ReusableSuccessMessage from "../successMesagePopup/ReusableSuccessMessage";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  vendor_all_completed_diner,
  vendor_reset_diner_request,
  vendor_seated_waittime_request,
  vendor_assign_check_table_number,
  get_diner_reservation,
  get_pending_diner,
  vendor_accept_pending_diner,
  change_table_status_table_management,
} from "../../../../store/actions/dashboardAction/addingAction";
import { get_new_subscription_for_vendor } from "../../../../store/actions/authAction";
import {
  sa_vd_mark_complete_diner,
  sa_vd_reset_diner_request,
  sa_whole_vd_seating_diner,
} from "../../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminSeatingAction";
import EditWaitTime from "../tableNumberPopup/EditWaitTime";
import isEmpty from "../../../../store/validation/is-Empty";
import EnterTableNumber from "../tableNumberPopup/EnterTableNumber";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { complete_all_orders } from "../../../../store/actions/OrderingAction/vendorOrderingAction";

export class DeletePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openSuccessRecord: false,
      allData: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.dataSend) !== nextState.allData) {
      return {
        allData: nextProps.dataSend,
      };
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };

  onOpenModalSuccessRecord = () => {
    this.setState({ openSuccessRecord: true });
  };
  onCloseModalSuccessRecord = () => {
    this.setState({ openSuccessRecord: false });
  };

  recordCompleted = (e) => {
    e.preventDefault();
    if (this.props.actionBy === "order") {
      const token = this.props.auth.user.accessToken;
      const formData = {
        markAllComplete: true,
      };
      this.props.complete_all_orders(token, formData, this.onSuccess);
    } else if (this.props.actionBy === "ADMIN") {
      const vendorId = this.props.adminSendVendorId;
      const token = this.props.auth.user.accessToken;
      const formData = {
        markAllComplete: true,
      };
      this.props.sa_vd_mark_complete_diner(
        formData,
        vendorId,
        token,
        this.onAdminSuccess
      );
    } else {
      const formData = {
        vendor_id: this.props.auth.user.VendorUser._id,
        token: this.props.auth.user.accessToken,
        markComplete: true,
      };
      this.props.vendor_all_completed_diner(formData, this.onSuccess, (err) =>
        this.onError(err)
      );
      this.setState({
        open: false,
        openSuccessRecord: true,
      });
    }
  };

  onAdminSuccess = (e) => {
    this.props.sa_whole_vd_seating_diner(
      this.props.auth.user.accessToken,
      this.props.adminSendVendorId,
      this.onDinerSuccess,
      this.onDinerErrors
    );
    this.onCloseModal();
  };

  onDinerSuccess = (e) => {
    console.log("On Pending Success");
  };
  onDinerErrors = (e) => {
    console.log("On Pending Error");
  };

  historyReset = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    if (this.state.allData.diner_status === "COMPLETED") {
      const formData = {
        diner_status: "SEATED",
        table_number: this.props.dataSend.table_number,
        vendor: vendor_id,
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    } else if (this.state.allData.diner_status === "SEATED") {
      const formData = {
        diner_status: "NOTSEATED",
        table_number: this.props.dataSend.table_number,
        vendor: vendor_id,
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    } else if (this.state.allData.diner_status === "NOTSEATED") {
      const formData = {
        diner_status: "PENDING",
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    } else {
      const formData = {
        diner_status: "PENDING",
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    }
  };

  historyReset = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    if (this.state.allData.diner_status === "COMPLETED") {
      const formData = {
        diner_status: "SEATED",
        table_number: this.props.dataSend.table_number,
        vendor: vendor_id,
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    } else if (this.state.allData.diner_status === "SEATED") {
      const formData = {
        diner_status: "NOTSEATED",
        table_number: this.props.dataSend.table_number,
        vendor: vendor_id,
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    } else if (this.state.allData.diner_status === "NOTSEATED") {
      const formData = {
        diner_status: "PENDING",
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    } else {
      const formData = {
        diner_status: "PENDING",
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.onAdminSuccessCallback
        );
      } else {
        this.props.vendor_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token
        );
        this.onCloseModal();
      }
    }
  };

  historyUnseated = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    const formData = {
      diner_status: "NOTSEATED",
      table_number: this.props.dataSend.table_number,
      vendor: vendor_id,
    };
    if (this.props.actionBy === "ADMIN") {
      this.props.sa_vd_reset_diner_request(
        formData,
        diner_id,
        vendor_id,
        token,
        this.onAdminSuccessCallback
      );
    } else {
      this.props.vendor_reset_diner_request(
        formData,
        diner_id,
        vendor_id,
        token
      );
      this.onCloseModal();
    }
  };

  historyCompleted = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    const formData = {
      diner_status: "COMPLETED",
      table_number: this.props.dataSend.table_number,
      vendor: vendor_id,
    };
    if (this.props.actionBy === "ADMIN") {
      this.props.sa_vd_reset_diner_request(
        formData,
        diner_id,
        vendor_id,
        token,
        this.onAdminSuccessCallback
      );
    } else {
      this.props.vendor_reset_diner_request(
        formData,
        diner_id,
        vendor_id,
        token
      );
      this.onCloseModal();
    }
  };

  seatingCompleted = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;

    this.props.change_table_status_table_management(
      this.props.subscription_id,
      this.props.dataSend.table_number,
      "AVAILABLE",
      token,
      vendor_id
    );

    const formData = {
      diner_status: "COMPLETED",
      table_number: this.props.dataSend.table_number,
      vendor: vendor_id,
    };
    if (this.props.actionBy === "ADMIN") {
      this.props.sa_vd_reset_diner_request(
        formData,
        diner_id,
        vendor_id,
        token,
        this.onAdminSuccessCallback
      );
    } else {
      this.props.vendor_seated_waittime_request(
        formData,
        diner_id,
        vendor_id,
        token,
        this.onSuccess
      );
      // this.onCloseModal();
    }
  };

  seatingUnseated = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    this.props.change_table_status_table_management(
      this.props.subscription_id,
      this.props.dataSend.table_number,
      "ON_HOLD",
      token,
      vendor_id
    );
    const formData = {
      diner_status: "NOTSEATED",
      table_number: this.props.dataSend.table_number,
      vendor: vendor_id,
    };
    if (this.props.actionBy === "ADMIN") {
      this.props.sa_vd_reset_diner_request(
        formData,
        diner_id,
        vendor_id,
        token,
        this.onSuccess
      );
    } else {
      this.props.vendor_assign_check_table_number(
        formData,
        diner_id,
        vendor_id,
        token,
        this.onSuccess,
        this.onError
      );
    }
    // this.props.get_diner_reservation(
    //   this.props.auth.user.VendorUser._id,
    //   this.props.auth.user.accessToken
    // );
  };

  onSuccess = (e) => {
    this.props.get_new_subscription_for_vendor({
      vendor_id:
        this.props.actionBy === "ADMIN"
          ? this.props.adminSendVendorId
          : this.props.auth.user.VendorUser._id,
    });
    this.props.get_diner_reservation(
      this.props.auth.user.VendorUser._id,
      this.props.auth.user.accessToken
    );
    this.props.get_pending_diner(
      this.props.auth.user.VendorUser._id,
      this.props.auth.user.accessToken
    );
    this.onCloseModal();
    if (this.props.getUpdatedData) this.props.getUpdatedData();
  };

  onMarkError = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onError = (e) => {
    Alert.error(`<h4>Table Number Already Assign</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  // ${err.response.data === undefined ? err : err.response.data.message}

  /***********************************************
   * @DESC Pending Reservation Accepted
   **********************************************/
  pendingReservationAccepted = (dataSend) => (e) => {
    e.preventDefault();
    const updatedTime = new Date(dataSend.reservationTime);
    const currentTimeTwo = new Date().getTime();
    const newcurrentTime = Math.floor(currentTimeTwo / (1000 * 60));
    const updatedTimeNew = updatedTime.getTime();
    const newUpdatedTime = Math.floor(updatedTimeNew / (1000 * 60));
    const waitTime = newUpdatedTime - newcurrentTime;
    const token = this.props.auth.user.accessToken;
    const diner_id = dataSend._id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    const formData = {
      // wait_time: waitTime,
      diner_status: "NOTSEATED",
      table_number: dataSend.table_number,
      vendor: vendor_id,
    };
    if (this.props.actionBy === "ADMIN") {
      this.props.sa_vd_reset_diner_request(
        formData,
        diner_id,
        vendor_id,
        token,
        this.successCallback
      );
    } else {
      this.props.vendor_accept_pending_diner(
        formData,
        diner_id,
        vendor_id,
        token,
        this.successCallback
      );
    }
  };

  successCallback = (e) => {
    Alert.success(`<h4>Reservation Add Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this.props.get_diner_reservation(
      this.props.auth.user.VendorUser._id,
      this.props.auth.user.accessToken
    );
    this.props.get_pending_diner(
      this.props.auth.user.VendorUser._id,
      this.props.auth.user.accessToken
    );
    this.onCloseModal();
  };

  onAdminSuccessCallback = (e) => {
    if (this?.props?.onSuccess) {
      this.props.onSuccess();
    }
    Alert.success(`<h4>Diner Record Update Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this.props.get_diner_reservation(
      this.props.auth.user.VendorUser._id,
      this.props.auth.user.accessToken
    );
    this.props.get_pending_diner(
      this.props.auth.user.VendorUser._id,
      this.props.auth.user.accessToken
    );
    this.onCloseModal();
  };

  render() {
    const { open, openSuccessRecord } = this.state;
    return (
      <React.Fragment>
        {this.props.buttonDisplay === "offerEventDelete" ? (
          <div className="offers-event-deletebutton">
            <Image
              src={require("../../../../assets/images/ActionImages/delete.png")}
              alt="Delete"
              title="Delete"
              className="offers-event-delete"
              onClick={this.onOpenModal}
            />
          </div>
        ) : null || this.props.buttonDisplay === "bigCancelButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="cancel"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "smallCancelButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="smallcancel"
            mobile={this.props.mobile}
            onClick={this.onOpenModal}
            buttonImage={this.props.IconButton}
            display={true}
          />
        ) : null || this.props.buttonDisplay === "smallSaveButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="smallsave"
            onClick={this.onOpenModal}
            buttonImage={this.props.IconButton}
          />
        ) : null || this.props.buttonDisplay === "acceptButtonReservation" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="smallsave"
            onClick={this.pendingReservationAccepted(this.props.dataSend)}
            buttonImage={this.props.IconButton}
          />
        ) : null || this.props.buttonDisplay === "seatingCompleted" ? (
          <PopupActionButton
            buttonText="Complete"
            buttonType="button"
            buttonClass="smallsave"
            allDataProps={this.props.dataSend}
            onClick={this.seatingCompleted}
            buttonImage={this.props.IconButton}
          />
        ) : null || this.props.buttonDisplay === "deleteButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="cancel"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "completedRecord" ? (
          <Image
            width="25px"
            src={require("../../../../assets/images/AuthImages/checked.png")}
            alt="Checked"
            title="All Record"
            className="checked-images"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "superAdminDeleteIcon" ? (
          <div className="super-admin-icon-box-width">
            <Image
              src={require("../../../../assets/images/ActionImages/delete.png")}
              alt="Delete"
              title="Delete Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminRemoveReview" ? (
          <div className="super-admin-icon-box-width">
            <Image
              src={require("../../../../assets/images/superadmin/removebutton.svg")}
              alt="Delete"
              title="Delete Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminApprovedReview" ? (
          <div className="super-admin-icon-box-width">
            <Image
              src={require("../../../../assets/images/superadmin/rightbutton.svg")}
              alt="Delete"
              title="Delete Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null ||
          this.props.buttonDisplay === "superAdminNotificationView" ? (
          <div className="super-admin-icon-box-width m-auto">
            <Image
              src={require("../../../../assets/images/OfferAndEventImages/view.png")}
              alt="View"
              title="View Icon"
              // onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminUserFlag" ? (
          <div className="super-admin-icon-box-width m-auto">
            <Image
              src={require("../../../../assets/images/iconButton/flag.png")}
              alt="View"
              title="View Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminUserBlock" ? (
          <div className="super-admin-icon-box-width m-auto">
            <Image
              src={require("../../../../assets/images/iconButton/lock.png")}
              alt="View"
              title="View Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null}
        <Modal
          open={open}
          onClose={this.onCloseModal}
          style={{ overlay: { background: "black" } }}
          center
          classNames={{
            // overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton:
              this.props.displayButton === true
                ? "customCloseButtonCalling"
                : "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <div className="reusable-popup-header-newstyle mr-3 mt-4">
              {this.props.display === true ? (
                <h4 className="c-black font_24_b">{this.props.bigText}</h4>
              ) : (
                <h4 className="c-black font_24_b">{this.props.bigText}</h4>
              )}
            </div>
            <h4 className="font_20_r mt-2 mb-5" style={{ textAlign: "left" }}>
              {this.props.reasonText}
            </h4>
            {/* <div className="bottom-button"> */}
            <div className="d-flex" style={{ justifyContent: "center" }}>
              <ReusableOnboardingButton
                buttonTitle="No Button"
                buttonClass={
                  "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                }
                buttonText="No"
                onClick={this.onCloseModal}
                buttonType="button"
                buttonStyle={{ maxWidth: "100px" }}
              />
              {this.props.displayPopup === "resonFforCancellation" ? (
                <ReasonForCancellation
                  buttonText="Yes"
                  cancelActionCall={this.props.actionCall}
                  onOpen={this.onOpenModal}
                  reasonText={this?.props?.reasonText}
                  noReason={this?.props?.noReason}
                  mobile={this.props.mobile}
                  closedMainModal={this.onCloseModal}
                  allDataProps={this.props.dataSend}
                  allDataPropsOne={this.props.dataSendOne}
                  style={{ width: "120px", minHeight: "40px" }}
                  cancelRequest={this.props.cancelRequest}
                />
              ) : null || this.props.displayPopup === "acceptButton" ? (
                <EditWaitTime
                  buttonText="Yes"
                  editButtonStatus="pendingEdit"
                  closedMainModal={this.onCloseModal}
                  allDataProps={this.props.dataSend}
                />
              ) : null || this.props.displayPopup === "SeatedButton" ? (
                <EnterTableNumber
                  buttonText="Yes"
                  editButtonStatus="pendingEdit"
                  buttonClass={
                    this.props.mobile ? "yesButton" : "bigbuttongray"
                  }
                  mobile={true}
                  closedMainModal={this.onCloseModal}
                  allDataProps={this.props.dataSend}
                />
              ) : null || this.props.displayPopup === "deleteButton" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="bigbuttongray"
                  onClick={this.props.deleteClick}
                />
              ) : null || this.props.displayPopup === "completedRecord" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.recordCompleted}
                />
              ) : null || this.props.displayPopup === "historyReset" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.historyReset}
                />
              ) : null || this.props.displayPopup === "historyUnseated" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.historyUnseated}
                />
              ) : null || this.props.displayPopup === "historyCompleted" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.historyCompleted}
                />
              ) : null || this.props.displayPopup === "seatingCompleted" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  allDataProps={this.props.dataSend}
                  onClick={this.seatingCompleted}
                />
              ) : null || this.props.displayPopup === "seatingUnseated" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  allDataProps={this.props.dataSend}
                  onClick={this.seatingUnseated}
                />
              ) : null}
              {/* <PopupActionButton
                buttonText="No"
                buttonType="button"
                buttonClass="bigbuttonred"
                onClick={this.onCloseModal}
              /> */}
            </div>
          </div>
        </Modal>
        <SuccessRecordPopup
          openSuccess={openSuccessRecord}
          onCloseModal={this.onCloseModalSuccessRecord}
          bigText="Record Success"
          smallText="No more requests to be completed"
        />
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => ({
  allDinnerDetails: state.allDinerDetails.vendor_all_diner,
  auth: state.auth,
  errors: state.errors.errors,
  subscription_id:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details._id,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  /***************************
   * @DESC Admin Api Action
   **************************/
  sa_vd_mark_complete_diner,
  sa_vd_reset_diner_request,
  sa_whole_vd_seating_diner,
  /***************************
   * @DESC Vendor Api Action
   **************************/
  get_new_subscription_for_vendor,
  vendor_all_completed_diner,
  vendor_reset_diner_request,
  vendor_seated_waittime_request,
  vendor_assign_check_table_number,
  get_diner_reservation,
  get_pending_diner,
  vendor_accept_pending_diner,
  complete_all_orders,
  change_table_status_table_management,
})(withRouter(DeletePopup));

const SuccessRecordPopup = ({
  openSuccess,
  onCloseModal,
  bigText,
  smallText,
}) => {
  return (
    <React.Fragment>
      <Modal
        open={openSuccess}
        onClose={onCloseModal}
        center
        style={{ overlay: { background: "black" } }}
        classNames={{
          // overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div>
          <div className="reusble-popup-header-style">
            <h4>{bigText}</h4>
          </div>
          <div className="bottom-button">
            <h4 className="col-12 mt-3">{smallText}</h4>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
